import React from 'react'
// Ant Design
import { Flex, Typography, Button } from 'antd'
// Ant Design Icons
import { PlusOutlined, LeftOutlined } from '@ant-design/icons'
// Config
import { getConfig } from '../../config'
const { Title } = Typography

export const Header = ({ t, addView, setAddView }) => {
    return (
        <Flex align="center" style={{ width: "100%", height: "60px", borderBottom: `2px solid ${getConfig("colorPrimario")}` }}>
            <Title level={3} style={{ marginBottom: "0" }}>{t("list_view")}</Title>
            {!addView
                ? <Button onClick={() => setAddView(true)} icon={<PlusOutlined />} style={{ marginLeft: "auto", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }}>{t("add_view")}</Button>
                : <Button onClick={() => setAddView(false)} icon={<LeftOutlined />} style={{ marginLeft: "auto", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}` }}>{t("back")}</Button>
            }
        </Flex>
    )
}
